module.exports = __webpack_public_path__ + "static/media/Game.450c4852.PNG";